module.exports = __webpack_public_path__ + "static/media/boss-bar-red-04.33d6dcb1.png";